const config = { clarityId: '89ezxzjtv3' };

export default config;
